import React, {Suspense} from "react";
import {useSelector} from 'react-redux';
import {useState} from 'react';

//components
import CollapseTab from '../../components/Tabs/CollapseTab';
import StatusIcon from '../../components/Icons/StatusIcon';
import Loading from "../../components/Loading/Loading";

//assets
import icon1 from '../../assets/icons/sections/infracciones_camaras_vias.svg';


export default () => {

    const OnCameraInfractionsContainer = React.lazy(() => import('./components/OnCameraInfractionsContainer'));
    const [show, setShow] = useState(false);
    let boxData = useSelector(state => state.app.data);
    boxData = boxData && boxData.multasviasexclusivas;


    return (
        <div onClick={() => setShow(!show)} id="multasviasexclusivas" className="OnCameraInfractionsSection">
            {
                boxData && boxData.body && boxData.header && boxData.footer &&
                <CollapseTab
                    sectionName="multasviasexclusivas"
                    carouselLength={boxData.body && boxData.body.data && Array.isArray(boxData.body.data) ? boxData.body.data.length : 0}
                    icon={icon1}
                    stateIcon={<StatusIcon
                        status={boxData.body && boxData.body.result && boxData.body.result.type}/>}
                    nav={<div
                        className="font-roboto font-bold font-14 txt-blue line-1-2">{boxData.header.title}</div>}>
                    <div onClick={(e) => e.stopPropagation()}>
                        <Suspense fallback={<Loading size='medium'/>}>
                            {show && <OnCameraInfractionsContainer boxData={boxData}/>}
                        </Suspense>
                    </div>
                </CollapseTab>
            }
        </div>
    )
}
